import React from 'react'
import { connect } from 'react-redux'
import Title from '../components/Title.jsx'
import Button from '../components/Button.jsx'

const ContactInfoContainer = (props) => {
    const contactInfoItems = props.langData.infoItems.map((val, key) => (
        <div className="col-md-6 col-sm-6" key={key}>
            <div className="about-contact-item">
                <img
                    className="about-contact-item__img"
                    src={`/images/ico/${val.icon}`}
                />
                <h2 className="about-contact-item__title">{val.title}</h2>
                <p className="about-contact-item__text">{val.phone}</p>
                <div className="contact-item__btn">
                    <Button
                        type="yellow"
                        text={val.btnText}
                        outsideLink={val.link}
                    />
                </div>
            </div>
        </div>

    ))

    return (
        <div className="section-spacing">
            <Title
                className="header1--center"
                title={props.langData.title}
            />
            <div className="container">
                <div className="row contact-info-row">
                    {contactInfoItems}
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = state => ({
    langData: state.langData.contact.contactInfo
})

export default connect(mapStateToProps)(ContactInfoContainer)



// WEBPACK FOOTER //
// ./src/scripts/containers/ContactInfoContainer.jsx